import { StringUtil } from "@mcleod/core";
import { AutogenLayoutEdiProfileRemitQuickInfo } from "./autogen/AutogenLayoutEdiProfileRemitQuickInfo";
import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { EdiUtility } from "./EdiUtility";
import { EdiRemitAdvProf } from "./EdiRemitAdvProf";

export class EdiProfileRemitQuickInfo extends AutogenLayoutEdiProfileRemitQuickInfo {
    doAfterExecute(event: DataSourceExecutionEvent) {
        if (StringUtil.isEmptyString(this.sourceEdiremitProfile.activeRow?.get("notes"))) {
            this.imagePartnerNotes.enabled = false;
            this.imagePartnerNotes.imageColor = "subtle.light";
            this.imagePartnerNotes.tooltip = "No partner notes available"
        }
    }

    openClassicPartnerProfile(event: ClickEvent): void {
        const id = this.sourceEdiremitProfile?.activeRow?.get("id");
        if (id != null) {
            EdiRemitAdvProf.navigateTo(id);
        }
    }

    showPartnerNotes() {
        EdiUtility.showPartnerNotes(this.sourceEdiremitProfile.activeRow?.get("id"),
            this.sourceEdiremitProfile.activeRow?.get("partner_name"), this.sourceEdiremitProfile.activeRow?.get("notes"));
    }
}